import $ from 'jquery'

export default class Filters {
    constructor() {
        if ($('.js-filters').length) {
            if ($('.js-filters').data('is-map') == true) {
                return
            }

            let active_filters = {}
            const $loader = $('.js-filters__loader')
            const $portfolio_items = $('.portfolio__items')
            const $remaining_terms = $('.js-filters__remaining-terms')
            const $show_more = $('.js-filters__show-more')
            const $show_less = $('.js-filters__show-less')
            const $filter_toggle = $('.js-filters__toggle')
            const $filter_drawer = $('.js-filters__drawer')

            $('body').on('click', '.js-filters__toggle', function() {
                const $this = $(this)

                $this.toggleClass('is-active')
                $filter_drawer.toggleClass('is-active')
            })

            $('body').on('click', '.js-filters__tab', function () {
                const $this = $(this)
                const tab_index = $this.data('tab-index')

                $('.js-filters__tab').removeClass('is-active')
                $this.addClass('is-active')

                $('.js-filters__tab').attr('aria-selected', 'false')
                $this.attr('aria-selected', 'true')

                $('.js-filters__drawer').removeClass('is-active')
                $(`.js-filters__drawer[data-drawer-index="${tab_index}"]`).addClass('is-active')

                $('.js-filters__drawer').attr('aria-hidden', 'true')
                $(`.js-filters__drawer[data-drawer-index="${tab_index}"]`).attr('aria-hidden', 'false')

                if (tab_index === 1) {
                    $portfolio_items.addClass('is-hidden')

                    if (window.portmanMap) {
                        setTimeout(() => {
                            window.portmanMap.resize()

                            if (window.portmanMapRefreshBounds) {
                                window.portmanMapRefreshBounds()
                            }
                        }, 100)
                    }
                } else {
                    $portfolio_items.removeClass('is-hidden')
                }
            })

            $('body').on('click', '.js-filters__show-more', function () {
                const $this = $(this)

                $remaining_terms.addClass('is-visible')
                $show_more.hide()
                $show_less.addClass('is-visible')

                $show_more.attr('aria-expanded', 'true')
                $show_less.attr('aria-expanded', 'true')
            })

            $('body').on('click', '.js-filters__show-less', function () {
                const $this = $(this)

                $remaining_terms.removeClass('is-visible')
                $show_less.removeClass('is-visible')
                $show_more.show()

                $show_less.attr('aria-expanded', 'false')
                $show_more.attr('aria-expanded', 'false')
            })

            $('body').on('click', '.js-filters__all-button', function () {
                const $this = $(this)
                const taxonomy = $this.data('taxonomy')
                const $drawer = $(`.js-filters__drawer[data-taxonomy="${taxonomy}"]`)

                $drawer.find('.js-filters__filter').removeClass('is-active')
                $this.addClass('is-active')

                $drawer.find('.js-filters__filter').attr('aria-pressed', 'false')
                $this.attr('aria-pressed', 'true')

                if (active_filters[taxonomy]) {
                    active_filters[taxonomy] = []
                }

                applyFilters()
            })

            $('body').on('click', '.js-filters__filter', function () {
                const $this = $(this)
                const taxonomy = $this.data('taxonomy')
                const termId = $this.data('term-id')
                const $drawer = $(`.js-filters__drawer[data-taxonomy="${taxonomy}"]`)
                const $allButton = $drawer.find('.js-filters__all-button')

                // Initialize the taxonomy key in active_filters if it doesn't exist
                if (!active_filters[taxonomy]) {
                    active_filters[taxonomy] = []
                }

                // Check if filter is already active
                if ($this.hasClass('is-active')) {
                    const index = active_filters[taxonomy].indexOf(termId)

                    // Remove filter if active
                    $this.removeClass('is-active')
                    $this.attr('aria-pressed', 'false')

                    if (index !== -1) {
                        active_filters[taxonomy].splice(index, 1)
                    }

                    if (active_filters[taxonomy].length === 0) {
                        $allButton.addClass('is-active')
                        $allButton.attr('aria-pressed', 'true')
                    }
                } else {
                    // Add filter if not active
                    $this.addClass('is-active')
                    $this.attr('aria-pressed', 'true')

                    active_filters[taxonomy].push(termId)

                    $allButton.removeClass('is-active')
                    $allButton.attr('aria-pressed', 'false')
                }

                if (!$('.js-filters__submit').length) {
                    applyFilters()
                }
            })

            $('body').on('click', '.js-filters__submit', function () {
                applyFilters()
            })

            function applyFilters() {
                const $filters = $('.js-filters')
                const post_type = $filters.data('post-type')

                $loader.addClass('is-active')

                // Run AJAX call to get items with specified filters
                $.ajax({
                    type: 'POST',
                    url: portman.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'filter_items',
                        post_type: post_type || 'post',
                        active_filters,
                    },
                    success: function (res) {
                        // Show all returned items
                        $('.js-filterable-items').html(res)

                        // Hide load more button
                        $('.js-load-more').hide()

                        // Hide filter drawer
                        $filter_toggle.removeClass('is-active')
                        $filter_drawer.removeClass('is-active')

                        $loader.removeClass('is-active')
                    },
                })
            }
        }
    }
}
